import { getCheckoutReleaseAmount } from '@/pages/dashboard/Financial/utils/financialFormat';
import { getBalance } from '@/services/financial';
import { useQuery } from '@tanstack/react-query';

export default function useCheckoutReleaseAmount({ enabled = true } = {}) {
  const { data, isLoading } = useQuery({
    queryKey: ['balance', 'default'],
    queryFn: () => getBalance(),
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    checkoutReleaseAmount: getCheckoutReleaseAmount(data?.pending, data?.antecipateAmount),
    isLoadingCheckoutReleaseAmount: isLoading,
  };
}
